export default __webpack_public_path__ + "static/media/driver-safety.dd680f6d.png";